import { MetricType } from "web-vitals";
 
const reportWebVitals = async (onPerfEntry?: (metric: MetricType) => void): Promise<void> => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    await import("web-vitals").then(({ onCLS, onINP, onFCP, onLCP, onTTFB }): Promise<void> => 
    {
       onCLS(onPerfEntry);
       onINP(onPerfEntry);
       onFCP(onPerfEntry);
       onLCP(onPerfEntry);
       onTTFB(onPerfEntry);
       return;
    });
   }
 };

 export default reportWebVitals;
